import { createSlice } from "@reduxjs/toolkit"

const initialState = {
    filter: "",
    sort: "",
    searchKeyword: "",
}

const filterSlice = createSlice({
    name: 'filter',
    initialState,
    reducers:{
        toggleFilter : (state, action) => {
            state.filter = action.payload
        },
        toggleSort: (state, action) => {
            state.sort = action.payload
        },
        searchJob: (state, action) => {
            state.searchKeyword = action.payload
        }
    }
})


export default filterSlice.reducer;
export const {toggleFilter, toggleSort, searchJob} = filterSlice.actions;